import React, { useState, useEffect } from "react";
import { useHistory } from "react-router-dom";
import { useSnackbar } from "notistack";
import { Button, Grid, TextField } from "@material-ui/core";
import Textbox from "../../ui_utilities/Textbox";
import { getEnvironment } from "../../../common/utils/utility";
import { SNACKBAR_TYPE } from "../../../common/constants/constants";
import {
  checkHerdCodeUniqueness,
  requestHerdAccess,
} from "../../../common/services/herd.service";
import TwoButtonDialog from "../../../common/dialogs/two-button-dialog/two-button-dialog";

const HerdCodeSection = (props) => {
  const ENV = getEnvironment();
  const history = useHistory();
  const { enqueueSnackbar } = useSnackbar();

  const [software_herd_software, setsoftware_herd_software] = useState(
    props.formdata["software_herd_software"].toLowerCase(),
  );
  const [isCheckingHerdCode, setIsCheckingHerdCode] = useState(false);
  const [herdCodeValidationMessage, setHerdCodeValidationMessage] =
    useState(null);
  const [herdCodeValidationType, setHerdCodeValidationType] = useState(null);
  const [showDuplicateHerdModal, setShowDuplicateHerdModal] = useState(false);
  const [duplicateHerdCode, setDuplicateHerdCode] = useState("");
  const [duplicateHerdMessage, setDuplicateHerdMessage] = useState("");
  const [isDuplicateOnSameSystem, setIsDuplicateOnSameSystem] = useState(false);
  const [duplicateSourceSystems, setDuplicateSourceSystems] = useState([]);

  let buttonClass = "psudeo-input-item";
  let activebuttonClass = "psudeo-input-item active";
  let drmsButtonClass = "";

  let disableDRMS = !["LOCAL", "DEV", "QA", "PROD"].includes(ENV);

  const handleCheckHerdCode = () => {
    const herdCode = props.formdata["software_herd_code"];
    const sourceSystem = props.formdata["software_herd_software"];

    if (!herdCode || herdCode.toString().trim() === "") {
      setHerdCodeValidationMessage("Please enter a herd code first");
      setHerdCodeValidationType("error");
      if (props.setHerdCodeValidationStatus) {
        props.setHerdCodeValidationStatus("error");
      }
      return;
    }

    if (!sourceSystem || sourceSystem.trim() === "") {
      setHerdCodeValidationMessage(
        "Please select the current herd software first",
      );
      setHerdCodeValidationType("error");
      if (props.setHerdCodeValidationStatus) {
        props.setHerdCodeValidationStatus("error");
      }
      return;
    }

    setIsCheckingHerdCode(true);
    setHerdCodeValidationMessage(null);
    setHerdCodeValidationType(null);

    const requestBody = {
      action: props.type === "edit" ? "edit" : "add",
      herd_code: herdCode.toString(),
      source_system: sourceSystem,
    };

    if (props.type === "edit" && props.herddata?.herd_id) {
      requestBody.herd_id = props.herddata.herd_id;
    }

    checkHerdCodeUniqueness(requestBody)
      .then((response) => {
        setIsCheckingHerdCode(false);
        if (response && response.status === "-1000") {
          const existingSystems = response.data?.source_systems || [];
          const isOnSameSystem = existingSystems.includes(sourceSystem);

          setDuplicateHerdCode(herdCode.toString());
          setDuplicateSourceSystems(existingSystems);
          setIsDuplicateOnSameSystem(isOnSameSystem);
          setDuplicateHerdMessage(
            response.message ||
              "This herd code already exists, please contact support@addieinsights.com to request access.",
          );
          setShowDuplicateHerdModal(true);

          if (isOnSameSystem) {
            setHerdCodeValidationMessage(null);
            setHerdCodeValidationType(null);
          } else {
            setHerdCodeValidationMessage(
              `Herd code exists on ${existingSystems.join(", ")}, but you can proceed with ${sourceSystem}`,
            );
            setHerdCodeValidationType("success");
          }

          if (props.setHerdCodeValidationStatus) {
            if (isOnSameSystem) {
              props.setHerdCodeValidationStatus("error");
            } else {
              props.setHerdCodeValidationStatus("success");
            }
          }
        } else if (response && response.status === "1") {
          // Check if data exists (herd code exists on different system)
          if (
            response.data &&
            response.data.source_systems &&
            response.data.source_systems.length > 0
          ) {
            // Herd code exists on different system - show modal but allow submission
            const existingSystems = response.data.source_systems;
            setDuplicateHerdCode(herdCode.toString());
            setDuplicateSourceSystems(existingSystems);
            setIsDuplicateOnSameSystem(false); // Different system
            setDuplicateHerdMessage(response.message || "OK");
            setShowDuplicateHerdModal(true);

            setHerdCodeValidationMessage(
              `Herd code exists on ${existingSystems.join(", ")}, but you can proceed with ${sourceSystem}`,
            );
            setHerdCodeValidationType("success");

            if (props.setHerdCodeValidationStatus) {
              props.setHerdCodeValidationStatus("success");
            }
          } else {
            // Truly unique - no data present
            setHerdCodeValidationMessage(
              "Herd code is currently not in the system",
            );
            setHerdCodeValidationType("success");
            if (props.setHerdCodeValidationStatus) {
              props.setHerdCodeValidationStatus("success");
            }
          }
        }
      })
      .catch((error) => {
        setIsCheckingHerdCode(false);
        setHerdCodeValidationMessage(
          "Error checking herd code. Please try again.",
        );
        setHerdCodeValidationType("error");
        if (props.setHerdCodeValidationStatus) {
          props.setHerdCodeValidationStatus("error");
        }
        console.error("Error checking herd code uniqueness:", error);
      });
  };

  if (props.type === "edit") {
    buttonClass += " disabled_button";
  }

  return (
    <section className="form-section">
      <header>
        <h3>Herd Code</h3>
      </header>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={6} md={3}>
          <TextField
            disabled={props.disableedit}
            className="text-field-root required-style"
            name="software_herd_code"
            id="software_herd_code"
            type="number"
            label="Herdcode *"
            variant="outlined"
            onChange={(event) => {
              if (event.target.value.toString().length <= 8) {
                let temp = { ...props.formdata };
                temp["software_herd_code"] = event.target.value;
                props.setformdata(temp);
                setHerdCodeValidationMessage(null);
                setHerdCodeValidationType(null);
                if (props.setHerdCodeValidationStatus) {
                  props.setHerdCodeValidationStatus(null);
                }
              }
            }}
            value={props.formdata["software_herd_code"]}
          />
          {props.formerror.software_herd_code ? (
            <div className="required-style">
              {props.formerror.software_herd_code}
            </div>
          ) : null}
        </Grid>
        {software_herd_software === "drms" && (
          <Grid item xs={12} sm={6} md={3}>
            <Textbox
              disableedit={props.disableedit}
              data={{
                formdata: props.formdata,
                setformdata: props.setformdata,
                className:
                  software_herd_software === "drms"
                    ? "text-field-root required-style"
                    : "text-field-root",
                name: "software_remote_access_code",
                id: "software_remote_access_code",
                type: "password",
                label: "RAC *",
                helpText: "Remote Access Code",
                autocomplete: "off",
              }}
            />
            {props.formerror.software_remote_access_code ? (
              <div className="required-style">
                {props.formerror.software_remote_access_code}
              </div>
            ) : null}
          </Grid>
        )}
        <Grid item xs={12} md={6}></Grid>
        <Grid item xs={12}>
          <label className="form-label">Current Herd Software *</label>
          <p className="form-label-description">
            Which software does the dairy currently use to manage this herd?
            This cannot be changed once a herd is enrolled. If a herd has more
            than one software on farm or has recently changed software, please
            complete a separate herd enrollment for each software you will use
            to generate reports.
          </p>
          <div className="psuedo-button-radio-group">
            <span
              className={
                software_herd_software === "pcdart"
                  ? activebuttonClass
                  : buttonClass
              }
              onClick={() => {
                if (!props.disableedit && props.type !== "edit") {
                  let temp = { ...props.formdata };
                  temp["software_herd_software"] = "PCDART";
                  temp["software_remote_access_code"] = "";
                  props.setformdata(temp);
                  setsoftware_herd_software("pcdart");
                  setHerdCodeValidationMessage(null);
                  setHerdCodeValidationType(null);
                  if (props.setHerdCodeValidationStatus) {
                    props.setHerdCodeValidationStatus(null);
                  }
                }
              }}
            >
              PCDART
            </span>
            <span
              className={
                software_herd_software === "dc305"
                  ? activebuttonClass
                  : buttonClass
              }
              onClick={() => {
                if (!props.disableedit && props.type !== "edit") {
                  let temp = { ...props.formdata };
                  temp["software_herd_software"] = "DC305";
                  temp["software_remote_access_code"] = "";
                  props.setformdata(temp);
                  setsoftware_herd_software("dc305");
                  setHerdCodeValidationMessage(null);
                  setHerdCodeValidationType(null);
                  if (props.setHerdCodeValidationStatus) {
                    props.setHerdCodeValidationStatus(null);
                  }
                }
              }}
            >
              DAIRY COMP 305
            </span>
            <span
              className={
                software_herd_software === "dplan"
                  ? activebuttonClass
                  : buttonClass
              }
              onClick={() => {
                if (!props.disableedit && props.type !== "edit") {
                  let temp = { ...props.formdata };
                  temp["software_herd_software"] = "DPLAN";
                  temp["software_remote_access_code"] = "";
                  props.setformdata(temp);
                  setsoftware_herd_software("dplan");
                  setHerdCodeValidationMessage(null);
                  setHerdCodeValidationType(null);
                  if (props.setHerdCodeValidationStatus) {
                    props.setHerdCodeValidationStatus(null);
                  }
                }
              }}
            >
              DAIRY PLAN
            </span>
            <span
              className={`${software_herd_software === "drms" ? activebuttonClass : buttonClass} ${drmsButtonClass}`}
              onClick={() => {
                if (
                  !props.disableedit &&
                  props.type !== "edit" &&
                  !disableDRMS
                ) {
                  let temp = { ...props.formdata };
                  temp["software_herd_software"] = "DRMS";
                  temp["software_breeds"] = [];
                  props.setformdata(temp);
                  setsoftware_herd_software("drms");
                  setHerdCodeValidationMessage(null);
                  setHerdCodeValidationType(null);
                  if (props.setHerdCodeValidationStatus) {
                    props.setHerdCodeValidationStatus(null);
                  }
                }
              }}
            >
              DRMS DHIA
            </span>
          </div>
        </Grid>
        <Grid item xs={12}>
          <Button
            variant="contained"
            className="button"
            onClick={handleCheckHerdCode}
            disabled={
              props.disableedit ||
              isCheckingHerdCode ||
              !props.formdata["software_herd_code"] ||
              props.formdata["software_herd_code"].toString().trim() === ""
            }
            style={{ marginTop: "16px" }}
          >
            {isCheckingHerdCode ? "Checking..." : "Check if herdcode exists"}
          </Button>
        </Grid>
        {herdCodeValidationMessage && (
          <Grid item xs={12}>
            <div
              style={{
                marginTop: "8px",
                padding: "8px 12px",
                borderRadius: "4px",
                fontSize: "14px",
                fontWeight: "500",
                backgroundColor:
                  herdCodeValidationType === "success" ? "#d4edda" : "#f8d7da",
                color:
                  herdCodeValidationType === "success" ? "#155724" : "#721c24",
                border: `1px solid ${herdCodeValidationType === "success" ? "#c3e6cb" : "#f5c6cb"}`,
                maxWidth: "fit-content",
              }}
            >
              {herdCodeValidationMessage}
            </div>
          </Grid>
        )}
      </Grid>

      {showDuplicateHerdModal ? (
        <TwoButtonDialog
          content={
            <>
              {duplicateSourceSystems.length > 0 && (
                <>
                  <span style={{ fontWeight: "bold", fontSize: "16px" }}>
                    This herd code exists on the following source system(s):{" "}
                    <strong>{duplicateSourceSystems.join(", ")}</strong>
                  </span>
                  <br />
                  <br />
                </>
              )}
              {isDuplicateOnSameSystem ? (
                <>
                  <span>
                    You cannot add this herd code with the same source system.
                    Would you like to request access to this herd instead?
                  </span>
                  <br />
                  <br />
                  <span style={{ fontSize: "14px" }}>
                    Please contact support@addieinsights.com to request access.
                  </span>
                </>
              ) : (
                <>
                  <span style={{ color: "#155724" }}>
                    You can proceed with adding this herd code since you're
                    using a different source system (
                    {props.formdata["software_herd_software"]}).
                  </span>
                  <br />
                  <br />
                  <span>
                    Would you like to request access to the existing herd, or
                    continue with your enrollment?
                  </span>
                  <br />
                  <br />
                  <span style={{ fontSize: "14px" }}>
                    Please contact support@addieinsights.com to request access.
                  </span>
                </>
              )}
            </>
          }
          open={showDuplicateHerdModal}
          handleClose={() => {
            setShowDuplicateHerdModal(false);
          }}
          btnText1="Request Access"
          btnText2={isDuplicateOnSameSystem ? "Cancel" : "Continue"}
          handleActionBtn1={async () => {
            setShowDuplicateHerdModal(false);

            try {
              const requestBody = {
                herd_code: duplicateHerdCode,
              };

              await requestHerdAccess(requestBody);

              enqueueSnackbar(
                "Access request submitted successfully. Support team will contact you shortly.",
                {
                  autoHideDuration: 5000,
                  variant: SNACKBAR_TYPE.SUCCESS,
                },
              );

              history.push("/dashboard/herds");
            } catch (error) {
              console.error("Error requesting herd access:", error);
              enqueueSnackbar(
                "Failed to submit access request. Please try again or contact support@addieinsights.com",
                {
                  autoHideDuration: 5000,
                  variant: SNACKBAR_TYPE.ERROR,
                },
              );
            }
          }}
          handleActionBtn2={() => {
            setShowDuplicateHerdModal(false);
          }}
        />
      ) : null}
    </section>
  );
};

export default HerdCodeSection;
